import { AxiosResponse } from 'axios';
import { ContractsStatuses } from 'interfaces/contracts';
import { GetContractsReqParams } from 'models/contracts';
import { build } from 'search-params';

import $http from './instance';

class ContractsClient {
  public static async getContracts(params: GetContractsReqParams): Promise<AxiosResponse> {
    const { offset, limit } = params;

    const query = build({
      offset: offset ?? 0,
      limit: limit ?? 10,
      status: ContractsStatuses.ACTIVE
    });

    return $http.get(`/contracts?${query}`);
  }
}

export default ContractsClient;
